import React from 'react';
import _ from 'lodash';
import Slider from '../Slider';
import ArrowLeft from '../icons/ArrowLeft';
import ArrowRight from '../icons/ArrowRight';

import Thumbnail from './components/Thumbnail';


const createArrowButton = (direction) => {
  return (props) => {
    const { color = '#00a9a7', className, style, onClick } = props;
    return (
      <button
        className={className}
        style={style}
        onClick={onClick}
      >
        {direction === 'left' ? <ArrowLeft width={30} fill={color} /> : <ArrowRight width={30} fill={color} />}
      </button>
    );
  }
}

const NextButton = createArrowButton('right');
const PrevButton = createArrowButton('left');


export default class extends React.Component {

  static defaultProps = {
    currentImage: 0,
    images: [],
  }

  constructor(props) {
    super(props);
    this.sliderRef = React.createRef();

    this.state = {
      offset: 0,
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.currentImage !== nextProps.currentImage) {
      this.setState({ offset: 0 });
			if (this.sliderRef && this.sliderRef.current) this.sliderRef.current.slickGoTo(nextProps.currentImage, true);
		}
  }

  gotoNext = () => this.props.onClickNext();
  gotoPrev = () => this.props.onClickPrev();

  moveThumbnailBackward = () => this.setState({ offset: this.state.offset - 3 });
  moveThumbnailForward = () => this.setState({ offset: this.state.offset + 3 });

  handleClickThumbnail = (index) => {
    this.setState({ offset: 0 });
    this.props.onClickThumbnail(index);
  }
  

  renderArrowPrev () {
		if (this.props.currentImage <= 0) return null;

		return (
  		<PrevButton color="#00a9a7" onClick={this.gotoPrev} />
  	);
	}
	renderArrowNext () {
    if (this.props.currentImage + 1 === _.size(this.props.images)) return null;
		return (
			<NextButton color="#00a9a7" onClick={this.gotoNext} />
		);
	}

  renderThumbArrowPrev () {
		return (
  		<PrevButton color="#666" onClick={this.moveThumbnailBackward} />
  	);
	}
	renderThumbArrowNext () {
    return (
			<NextButton color="#666" onClick={this.moveThumbnailForward} />
		);
  }
  
  renderCaptionBar = () => {
    const { currentImage, images } = this.props;
    const image = images[currentImage];
    if (image) {
      return (
        <div className="gallery-lightbox-captionbar">
          {image.caption !== "" &&
            <div className="container-caption">
              <div className="caption">{image.caption}</div>
            </div>
          }
          <div className="count">{currentImage + 1} / {_.size(images)}</div>
        </div>
      );
    }
  }
  renderThumbnails = () => {
    const { images, currentImage } = this.props;

		const thumbnails = images;
		const arrowWidth = 40;
    const thumbWidth = 120;
    const thumbnailsWidth = window.innerWidth - 2 * arrowWidth;
    const moverWidth = _.size(images) * thumbWidth;

    const posX = (.5 * window.innerWidth) - arrowWidth + (-this.state.offset - currentImage - 0.5) * thumbWidth;
    let clampedPosX = _.clamp(posX, thumbnailsWidth - moverWidth, 0);

    if (thumbnailsWidth > moverWidth) clampedPosX = 0.5 * (thumbnailsWidth - moverWidth);

    const isShowArr = (window.innerWidth > moverWidth) ? false : true;
    
    return (
			<div className="thumbnails">
				{ isShowArr && <div className="thumb-arrow" style={{ width: arrowWidth }}>{posX < 0 && this.renderThumbArrowPrev()}</div> }
				<div style={{ width: `calc(100vw - ${2 * arrowWidth}px)`, overflow: 'hidden' }}>
					<div
            className="mover"
						style={{
							transition: 'transform .3s ease-out',
							transform: `translateX(${clampedPosX}px)`
						}}
					>
						{thumbnails.map((img, idx) => (
              <Thumbnail
                key={idx}
                {...img}
                index={idx}
                onClick={this.handleClickThumbnail}
                active={idx === currentImage}
              />
            ))}
					</div>
				</div>
        { isShowArr && <div className="thumb-arrow" style={{ width: arrowWidth }}>{thumbnailsWidth - posX < moverWidth && this.renderThumbArrowNext()}</div> }
			</div>
    );
  }
  
  render() {
    const { currentImage, images } = this.props;
    return (
      <div className="gallery-lightbox">
        <div className="content">
          <Slider
            sliderRef={this.sliderRef}
            settings={{
              initialSlide: currentImage,
              dots: false,
              autoplay: false,
              speed: 300,
              arrows: false,
            }}
            items={images}
            uiRenderer={image => {
              return (
                <div key={image.src} style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={_.get(image, "src")} alt="" />
                </div>
              );
            }}
          />
          <div className="btn-arrow btn-prev">{this.renderArrowPrev()}</div>
          <div className="btn-arrow btn-next">{this.renderArrowNext()}</div>
        </div>
        <div className="gallery-lightbox-footer">
          {this.renderCaptionBar()}
          {this.renderThumbnails()}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/GalleryLightbox/index.js